/**
 * zel-finance.doseo
 * @since       12.09.2017 14:13
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */

import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import 'ion-rangeslider';
import 'ion-rangeslider/css/ion.rangeSlider.css';
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import Vue from 'vue';
import VueForm from 'vue-form';
import 'whatwg-fetch';
import replace from './components/autoReplace';
import Calculator from './components/Calculator/Calculator.vue';
import CallbackForm from './components/CallbackForm.vue';
import OrderTariffForm from './components/OrderTariffForm.vue';
import Checkbox from './components/Checkbox.vue';
import ConsultForm from './components/ConsultForm/ConsultForm.vue';
import CoolMenu from './components/CoolMenu';
import FormStatus from './components/FormStatus.vue';
import hamburger from './components/hamburger';
import fixedbar from './components/fixed-bar';
import Modal from './components/Modal.vue';
import News from './components/News/News.vue';
import Radio from './components/Radio.vue';
import initToTop from './components/totop';
import transitionEvent from './components/whichTransitionEvent';
import YandexMap from './components/YandexMap.vue';


console.info(`Vue version ${Vue.version}, ${process.env.NODE_ENV} mode`);
Vue.config.devtools      = Vue.config.devtools || location.hostname === 'localhost';
Vue.config.productionTip = Vue.config.productionTip && location.hostname !== 'localhost';

Vue.use(VueForm);
Vue.component('modal', Modal);
Vue.component('callback-form', CallbackForm);
Vue.component('order-tariff-form', OrderTariffForm);
Vue.component('consult-form', ConsultForm);
Vue.component('form-status', FormStatus);
Vue.component('yandex-map', YandexMap);
Vue.component('news', News);
Vue.component('radio', Radio);
Vue.component('checkbox', Checkbox);
Vue.component('calculator', Calculator);

replace(document.body, {
  'icon-yes': '<span class="icon icon_yes"></span>',
  'icon-no' : '<span class="icon icon_no"></span>',
});

new Vue({
  delimiters: ['((', '))'],

  el: '#root',

  data: {
    modalShow     : false,
    modalHeading  : '',
    modalComponent: 'callback-form',
    selectedTariff: 1,
  },

  mounted() {
    console.log('root mounted');
    document.body.classList.toggle('is-locked', this.modalShow);
  },

  watch: {
    modalShow(newState) {
      document.body.classList.toggle('is-locked', newState);
    },
  },

  methods: {
    modal(heading, component) {
      this.modalHeading   = heading;
      this.modalComponent = component;
      this.modalShow      = true;
    },

    orderTariff(tariff) {
      this.selectedTariff = tariff;
      this.modal('Заказать тариф', 'order-tariff-form');
    },

    showCalc(title) {
      this.modal(title || 'Калькулятор', 'calculator');
    },
  },
});

hamburger({
  button        : 'js-menu-toggle',
  stateOpenClass: 'hamburger_state_cross',
  stateOpenFlag : 'f-hamburger-open',
});

fixedbar(document.querySelector('.fixed-bar'), {});

new CoolMenu({
  source : ['.top-menu__items', '.navbar-menu'],
  $button: $('.js-mobile-toggle'),
});

$('.navi__item_has_children').prepend('<div class="navi__backdrop"></div>');
$('.navi__item_has_children > .navi__link').on('click', function(e) {
  e.preventDefault();
  $(this).parent().toggleClass('navi__item_state_open');
});
$('.navi__backdrop').on('click', function() {
  $('.navi__item_state_open').removeClass('navi__item_state_open');
});

$('.search__button').on('click', function(e) {
  e.preventDefault();
  $(this).parent().toggleClass('search_state_open');
});
$('.search__backdrop').on('click', function() {
  $('.search_state_open').removeClass('search_state_open');
});

$('.js-experts-carousel').each((i, e) => {
  let $car = $(e);

  $car.find('.carousel__carousel').slick({
    arrows        : true,
    slidesToShow  : 2,
    slidesToScroll: 1,
    infinite      : false,
    prevArrow     : $car.find('.slider-button_prev'),
    nextArrow     : $car.find('.slider-button_next'),
    responsive    : [
      {
        breakpoint: 991,
        settings  : {
          slidesToShow: 1,
        },
      },
    ],
  });
});

$('.js-reviews-carousel').each((i, e) => {
  let $car = $(e);

  $car.find('.carousel__carousel').slick({
    arrows        : true,
    slidesToShow  : 3,
    slidesToScroll: 1,
    infinite      : false,
    prevArrow     : $car.find('.slider-button_prev'),
    nextArrow     : $car.find('.slider-button_next'),
    responsive    : [
      {
        breakpoint: 1199,
        settings  : {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings  : {
          slidesToShow: 1,
        },
      },
    ],
  });
});

$('.top-slider').each((i, e) => {
  let $slider   = $(e);
  let $carousel = $('.top-slider__carousel', $slider);

  $carousel.slick({
    arrows        : true,
    slidesToShow  : 1,
    slidesToScroll: 1,
    infinite      : false,
    prevArrow     : $slider.find('.slider-button_prev'),
    nextArrow     : $slider.find('.slider-button_next'),
  });
});

$('.js-brands-carousel').each((i, e) => {
  let $slider = $(e);

  $('.brands-carousel__items', $slider).slick({
    arrows       : true,
    infinite     : true,
    variableWidth: true,
    centerMode   : true,
    prevArrow    : $slider.find('.slider-button_prev'),
    nextArrow    : $slider.find('.slider-button_next'),
  });
});

$('.js-fancy').fancybox();

(function() {
  let activeClass    = 'is-active';
  let animationClass = 'in';

  $('.tab-container').each(function() {
    let $tabContainer = $(this);
    let $tabList      = $('.tab', $tabContainer);
    let $paneList     = $('.tab-pane', $tabContainer);

    $tabList.each((index, el) => {
      let $tab = $(el);

      $tab.on('click', event => {
        event.preventDefault();

        if (!$tab.hasClass(activeClass)) {

          $tabList.removeClass(activeClass);
          $tab.addClass(activeClass);

          let $activePane = $paneList.filter(`.${activeClass}`);
          let $nextPane   = $paneList.eq(index);

          $activePane.removeClass(animationClass);
          $activePane.one(transitionEvent, () => {
            $activePane.removeClass(activeClass);
            $nextPane.addClass(activeClass);
            setTimeout(() => $nextPane.addClass(animationClass), 0);
          });
        }
      });
    });
  });
})();

initToTop('.totop');



// WEBPACK FOOTER //
// ./source/js/main.js